import {Asset, Folder} from '../Assets.types';

/**
 * Recursively extracts all assets from an AssetFolderTree
 * @param tree - The asset folder tree to traverse
 * @returns Array of all assets found in the tree
 */
export default function getAllAssetsFromTree(tree: Folder | null): Asset[] {
  if (!tree) {
    return [];
  }

  const assets: Asset[] = [];

  // Add assets from current folder
  if (tree.assets) {
    assets.push(...tree.assets);
  }

  // Recursively add assets from subfolders
  if (tree.folders) {
    for (const subfolder of tree.folders) {
      assets.push(...getAllAssetsFromTree(subfolder));
    }
  }

  return assets;
}

